<template>
  <div class="haep">
    <div class="nophone">
      <img width="56" height="56" src="../../assets/image/bdsjzh.png" alt="手机绑定">
      <div class="text">尚未绑定手机账号，您可以：</div>
      <el-button plain @click="bindingid(1)">绑定已有手机账号</el-button>
      <el-button plain @click="bindingid(2)">注册新账号</el-button>
      <el-button type="text" @click="bindingid(3)">返回重新扫码</el-button>
    </div>

  </div>


</template>

<script>

export default {
  name:"nophone",
  data() {
    return{


    }
  },
  created() {

  },
  methods: {
    // 绑定已有账号
    bindingid(type){
      this.$emit('isphone',type);
    },

  }
}
</script>

<style scoped>
  .nophone /deep/ .el-button{
    margin-top: 20px;
    width: 100%;
  }
  .nophone /deep/ .el-button--default{
    border-color: #F9BD00;
  }
  .nophone /deep/ .el-button+.el-button {
    margin-left: 0px;

  }
  .nophone /deep/ .el-button.is-plain:hover{
    background: #F9BD00;
    color: #fff;
  }
  .nophone .text{
    font-size: 14px;
    font-weight: 500;
    color: #666666;
    opacity: 1;
    margin-top: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/components/denlu/nophone.vue